exports = module.exports = require("../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".register .form-box{padding:10px 0}.register .ant-row{padding:5px 10px;border-bottom:1px solid #ececec}.register .ant-row .ant-col-5{line-height:33px;text-align:left;font-size:14px;color:#000}.register .ant-row .three-word{padding:0 7px}.register .ant-row .ant-input{border:none!important;box-shadow:none!important;font-size:12px}.register .ant-input.reg-code{position:relative;top:4px;width:80px;height:25px;color:#fff;border-radius:4px;background-color:#18b4ed;text-align:center;padding-left:8px}.register .agree-box{display:block;padding:15px 10px}.register .agree-box span{vertical-align:middle}.register .next-btn{text-align:center}.register .next-btn button{width:95%;height:40px;line-height:40px;border:none;background-color:#18b4ed!important;color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./src/styles/register.css
// module id = 806
// module chunks = 0